import classnames from "classnames";
import { Link } from "react-router-dom";
import { Chevron } from "../Chevron/Chevron";
import "./_link-block.scss";
import { SvgInline } from "../SvgInline/SvgInline";

function LinkBlock(props) {
  const {
    chevronDirection,
    children,
    className,
    fgColor,
    flexHeight,
    iconName,
    noBorder,
    to,
    trackId,
    ...otherProps
  } = props;
  const svgColAttrs = {};

  if (iconName) {
    if (fgColor === "blue") {
      svgColAttrs.strokeBlueBright = true;
      svgColAttrs.fillBlueBright = true;
    } else if (fgColor === "white") {
      svgColAttrs.strokeWhite = true;
      svgColAttrs.fillWhite = true;
    }
  }

  const Inner = (
    <>
      {iconName && (
        <div className="link-block__icon">
          <SvgInline
            name={iconName}
            className="h-100 mr-3 w-auto"
            {...svgColAttrs}
          />
        </div>
      )}
      {children}
      <div className="link-block__chevron ml-auto">
        <Chevron
          direction={chevronDirection}
          strokeBlueBright={fgColor === "blue"}
          strokeWhite={fgColor === "white"}
        />
      </div>
    </>
  );
  const classes = classnames(
    "link-block",
    "d-flex",
    "w-100",
    "text-left",
    "align-items-center",
    iconName && "link-block--icon",
    noBorder && "link-block--no-border",
    fgColor !== LinkBlock.defaultProps.fgColor && `link-block--text-${fgColor}`,
    flexHeight && "link-block--flex-height",
    className,
  );

  return to ? (
    <Link to={to} trackId={trackId} noStyle className={classes} {...otherProps}>
      {Inner}
    </Link>
  ) : (
    <button className={classes} type="button" {...otherProps}>
      {Inner}
    </button>
  );
}

LinkBlock.defaultProps = {
  fgColor: "grey-dark",
  chevronDirection: "right",
};

export { LinkBlock };
